module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_6.8d95a8d4e89c1af84dc650bef4b2d186.png";